var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "bottom_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        rules: _vm.rules,
        "hide-required-asterisk": "",
      },
    },
    [
      _c("div", { staticClass: "label" }, [_vm._v("导航样式配置")]),
      _c(
        "el-form-item",
        { attrs: { prop: "bg_type" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.bg_type,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "bg_type", $$v)
                },
                expression: "value.config.bg_type",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("背景色")]),
              _c("el-radio", { attrs: { label: "2" } }, [_vm._v("背景图片")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.value.config.bg_type === "1"
        ? _c(
            "el-form-item",
            { attrs: { prop: "bg_color" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.value.config.bg_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "bg_color", $$v)
                  },
                  expression: "value.config.bg_color",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.value.config.bg_type === "2"
        ? _c("div", { staticClass: "box bg_img" }, [
            _c(
              "div",
              { staticClass: "uploadBox disableMode" },
              [
                _c("el-form-item", { attrs: { prop: "bg_img" } }, [
                  _c(
                    "div",
                    { staticClass: "upload-item-wrap" },
                    [
                      _c("upload-file", {
                        ref: "uploadBgImg",
                        attrs: {
                          "link-url": _vm.linkUrl,
                          tempurl: _vm.value.config.bg_img,
                          disabled: _vm.disabled,
                          canDel: Boolean(_vm.value.config.bg_img),
                          uploadInfo: _vm.uploadInfo,
                        },
                        on: {
                          onDelete: function ($event) {
                            return _vm.delImg(_vm.value.config, "bg_img")
                          },
                          emitUploadFile: function (res) {
                            return _vm.emitUploadFile(
                              res,
                              _vm.value.config,
                              "bg_img"
                            )
                          },
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "right" },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.onUpload("uploadBgImg")
                                },
                              },
                            },
                            [_vm._v("上传图片")]
                          ),
                          _vm.pictureInfo[2]
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectPicture(2, "bg_img")
                                    },
                                  },
                                },
                                [_vm._v("选择图片")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "label" }, [
        _vm._v(" 分类样式说明 "),
        _c("span", { staticClass: "tips" }, [
          _vm._v("（每个分类支持独自选择样式）"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "explain-content" },
        _vm._l(_vm.explainList, function (item) {
          return _c(
            "div",
            { key: item.key, staticClass: "explain-box" },
            [
              _c("el-image", {
                staticClass: "img",
                attrs: {
                  fit: "contain",
                  src:
                    "https://res.youlianfuwu.com/mini_program/shop/bottom_" +
                    item.key +
                    ".png",
                },
              }),
              _c("div", { staticClass: "name" }, [_vm._v(_vm._s(item.label))]),
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "label" }, [
        _vm._v(" 设置分类及排序 "),
        _c("span", { staticClass: "tips" }, [_vm._v("（拖动分类可调整排序）")]),
      ]),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, class: ["box", !item.flag && "disabled"] },
            [
              _c(
                "div",
                { staticClass: "list name" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".flag",
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              return _vm.checkFlag(rule, value, callback)
                            },
                          },
                        ],
                      },
                    },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(" " + _vm._s(item.name) + " "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "value" },
                        [
                          item.type === "normal"
                            ? _c("i", {
                                staticClass: "el-icon el-icon-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.delClassify(index)
                                  },
                                },
                              })
                            : _vm._e(),
                          _c("el-switch", {
                            attrs: {
                              "active-value": true,
                              "inactive-value": false,
                            },
                            model: {
                              value: item.flag,
                              callback: function ($$v) {
                                _vm.$set(item, "flag", $$v)
                              },
                              expression: "item.flag",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "disableMode" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("选择样式")]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "value." + index + ".style" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: item.style,
                            callback: function ($$v) {
                              _vm.$set(item, "style", $$v)
                            },
                            expression: "item.style",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("图文小图模式"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("图文大图模式"),
                          ]),
                          _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("全图模式"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              item.style !== "3"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "文字展示",
                          "label-width": "60px",
                          prop: "value." + index + ".name_alias",
                          rules: item.flag
                            ? [
                                {
                                  required: true,
                                  message: "展示名称不可为空",
                                  trigger: "change",
                                },
                                {
                                  max: 10,
                                  message: "名称长度最多10个字",
                                  trigger: "change",
                                },
                              ]
                            : [],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", disabled: !item.flag },
                          model: {
                            value: item.name_alias,
                            callback: function ($$v) {
                              _vm.$set(item, "name_alias", $$v)
                            },
                            expression: "item.name_alias",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字号", "label-width": "60px" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 10,
                            max: 50,
                            disabled: !item.flag,
                            size: "medium",
                          },
                          model: {
                            value: item.font_size,
                            callback: function ($$v) {
                              _vm.$set(item, "font_size", $$v)
                            },
                            expression: "item.font_size",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "grid",
                          "grid-template-columns": "repeat(2, 1fr)",
                          gap: "14px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "颜色（未选中）",
                              prop: "value." + index + ".font_color",
                              rules: [
                                {
                                  required: true,
                                  message: "请选择颜色",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-color-picker", {
                              attrs: { disabled: !item.flag },
                              model: {
                                value: item.font_color,
                                callback: function ($$v) {
                                  _vm.$set(item, "font_color", $$v)
                                },
                                expression: "item.font_color",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "颜色（选中）",
                              prop: "value." + index + ".active_font_color",
                              rules: [
                                {
                                  required: true,
                                  message: "请选择颜色",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-color-picker", {
                              attrs: { disabled: !item.flag },
                              model: {
                                value: item.active_font_color,
                                callback: function ($$v) {
                                  _vm.$set(item, "active_font_color", $$v)
                                },
                                expression: "item.active_font_color",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.info.category_id && item.type === "category_home"
                ? _c(
                    "div",
                    { staticClass: "list disableMode" },
                    [
                      _c("div", { staticClass: "label nickName" }, [
                        _vm._v("是否跟随卡规则显示菜单名"),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { flex: "1", "margin-bottom": "0" },
                          attrs: {
                            prop: "value." + index + ".show_rule_menusname",
                            rules: [
                              {
                                required: item.flag,
                                message: "选项不可为空",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: !item.flag },
                              model: {
                                value: item.show_rule_menusname,
                                callback: function ($$v) {
                                  _vm.$set(item, "show_rule_menusname", $$v)
                                },
                                expression: "item.show_rule_menusname",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.categoryMode && item.type === "category"
                ? _c("div", { staticClass: "menus_page_style disableMode" }, [
                    _c(
                      "div",
                      { staticClass: "label" },
                      [
                        _vm._v(" 分类页菜单模式 "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.jumpCategory($event)
                              },
                            },
                          },
                          [_vm._v(" 去装修 ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "uploadBox disableMode" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("图标（未选中）"),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".imageurl",
                        rules: item.flag
                          ? [
                              {
                                required: true,
                                message: "图标（未选中）不可为空",
                              },
                            ]
                          : [],
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-item-wrap" },
                        [
                          _c("upload-file", {
                            ref: "uploadBanner",
                            refInFor: true,
                            attrs: {
                              "link-url": _vm.linkUrl,
                              tempurl: item.imageurl,
                              disabled: !item.flag,
                              canDel: Boolean(item.imageurl),
                              uploadInfo: _vm.uploadInfo,
                            },
                            on: {
                              onDelete: function ($event) {
                                return _vm.delImg(item, "imageurl")
                              },
                              emitUploadFile: function (res) {
                                return _vm.emitUploadFile(res, item, "imageurl")
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUpload(index * 2 + 0)
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                              _vm.pictureInfo[1]
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectPicture(
                                            1,
                                            "imageurl",
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("选择图片")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "uploadBox disableMode" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("图标（选中）")]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".active_imageurl",
                        rules: item.flag
                          ? [
                              {
                                required: true,
                                message: "图标（选中）不可为空",
                              },
                            ]
                          : [],
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-item-wrap" },
                        [
                          _c("upload-file", {
                            ref: "uploadBanner",
                            refInFor: true,
                            attrs: {
                              "link-url": _vm.linkUrl,
                              tempurl: item.active_imageurl,
                              disabled: !item.flag,
                              canDel: Boolean(item.active_imageurl),
                              uploadInfo: _vm.uploadInfo,
                            },
                            on: {
                              onDelete: function ($event) {
                                return _vm.delImg(item, "active_imageurl")
                              },
                              emitUploadFile: function (res) {
                                return _vm.emitUploadFile(
                                  res,
                                  item,
                                  "active_imageurl"
                                )
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUpload(index * 2 + 1)
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                              _vm.pictureInfo[1]
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectPicture(
                                            1,
                                            "active_imageurl",
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("选择图片")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              item.type === "normal"
                ? _c(
                    "div",
                    { staticClass: "disableMode" },
                    [
                      _c("config-menu", {
                        key: item.uid,
                        attrs: {
                          value: item,
                          type: _vm.value.key,
                          index: index,
                          info: _vm.info,
                          menuList: _vm.menuList,
                          childrenMenuList: _vm.childrenMenuList,
                          customerModuleList: _vm.customerModuleList,
                          eBookCategoryList: _vm.eBookCategoryList,
                          aBookCategoryList: _vm.aBookCategoryList,
                          customerPackageList: _vm.customerPackageList,
                          systemMenus: _vm.systemMenus,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
      _c(
        "el-button",
        {
          staticStyle: { width: "100%", "margin-top": "10px" },
          attrs: { type: "primary", icon: "el-icon-plus" },
          on: { click: _vm.addClassify },
        },
        [_vm._v(" 添加分类 ")]
      ),
      _c("div", { staticClass: "label" }, [
        _c("span", { staticClass: "tips" }, [
          _vm._v("支持PNG、JPG等格式，2M以内，建议尺寸为44*44"),
        ]),
      ]),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureIndex: _vm.pictureIndex,
              depot: _vm.depot,
              pictureList: _vm.pictureList,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }